import { ScrollArea, Table, Text } from "@mantine/core";
import { RowDataAdmin } from "../AdminPage/types";
import { props } from "../AdminPage/props";
import { RowDataTypesMap } from "../types/RowDataTypes";
import { RowDataMember } from "../MemberPage/types";
import { RowDataTransaction } from "../TransactionPage/types";
import { RowDataStaff } from "../StaffPage/types";
import classes from "./CustomTable.module.css";
import React from "react";
import { RowDataKPIObjective } from "../KpiPage/types";
import { RowDataMain } from "../MainPage/types";
import { RowDataBanner } from "../BannerPage/types";
import { RowDataVoucher } from "../VoucherPage/types";
import { RowDataNotification } from "../Notification/types";
import { RowDataOrder } from "../OrderPage/types";
import { RowDataMerchandise } from "../MerchandisePage/types";
import { RowDataDealer } from "../DealerPage/types";
import { RowDataPDFPriceList } from "../PDFPriceListPage/types";
import { RowDataSplashScreen } from "../SplashScreenPage/types";
import { RowDataPrebuild } from "../PrebuildPage/types";
import { RowDataTerms } from "../TermsPage/types";
import { RowDataCorporate } from "../CorporatePage/types";
import { RowDataDealerRebate } from "../DealerRebatePage/types";
import { RowDataBdayVoucher } from "../VoucherBirthdayPage/types"; 
import { RowDataPCComponent } from "../PCComponentIncompletePage/types";
import { RowDataPCComponentParameter } from "../PCComponentParameterPage/types";
import { RowDataStoreItem as RowDataStoreItemIncomplete } from "../StoreItemIncompletePage/types";
import { RowDataStoreItem } from "../StoreItemPage/types";
import { RowDataGPU, RowDataGames } from "../GamesFPSPage/types";
import { RowDataBuildConfigPrebuild } from "../BuildConfigPrebuildPage/types";
import { RowDataBuildConfigCustom } from "../BuildConfigCustomPage/types";
import { RowDataBannerWeb } from "../BannerWebPage/types";
import { RowDataReview } from "../ReviewPage/types";
import { RowDataWebOrder } from "../WebOrderPage/types";
import { RowDataContactUs } from "../ContactUsPage/types";
import { RowDataContact } from "../ContactPage/types";

type RowDataKeys =
  | keyof RowDataAdmin
  | keyof RowDataMember
  | keyof RowDataTransaction
  | keyof RowDataKPIObjective
  | keyof RowDataStaff
  | keyof RowDataMain
  | keyof RowDataBanner
  | keyof RowDataVoucher
  | keyof RowDataNotification
  | keyof RowDataOrder
  | keyof RowDataMerchandise
  | keyof RowDataDealer
  | keyof RowDataPDFPriceList
  | keyof RowDataSplashScreen
  | keyof RowDataPrebuild
  | keyof RowDataTerms
  | keyof RowDataCorporate
  | keyof RowDataDealerRebate
  | keyof RowDataBdayVoucher
  | keyof RowDataPCComponent
  | keyof RowDataPCComponentParameter
  | keyof RowDataStoreItem
  | keyof RowDataStoreItemIncomplete
  | keyof RowDataGPU
  | keyof RowDataGames
  | keyof RowDataBuildConfigPrebuild
  | keyof RowDataBuildConfigCustom
  | keyof RowDataBannerWeb
  | keyof RowDataReview
  | keyof RowDataWebOrder
  | keyof RowDataContactUs
  | keyof RowDataContact;

interface Table {
  colHeaders: string[];
  filters: string[];
  reverseSortDirection: boolean;
  sortBy: RowDataKeys | null;
  setSorting(field: any): void;
  customclasses: { readonly [key: string]: string };
  Th({ children, sortable, reversed, sorted, onSort }: props): JSX.Element;
  rowData: RowDataTypesMap[keyof RowDataTypesMap][] | null;
  rows: JSX.Element[];
}

export const CustomTable: React.FC<Table> = React.memo<Table>(
  ({
    colHeaders,
    filters,
    reverseSortDirection,
    sortBy,
    setSorting,
    customclasses,
    Th,
    rowData,
    rows,
  }) => {
    const tableHeader: JSX.Element[] = [];
    // console.log("s");
    // console.log("its set here");
    // console.log(rowData);
    // console.log(filters);
    for (let i = 0; i < colHeaders.length; i++) {
      tableHeader.push(
        <Th
          sortable
          reversed={reverseSortDirection}
          sorted={sortBy === filters[i]}
          onSort={() => setSorting(filters[i])}
        >
          {colHeaders[i]}
        </Th>
      );
    }

    return (
      <div className={classes.parentTable + " " + customclasses.parentTable}>
        <Table
          striped
          horizontalSpacing="xs"
          verticalSpacing="xs"
          className={classes.wholetable + " " + customclasses.wholetable}
        >
          <Table.Thead>
            <Table.Tr
              className={
                classes.tableHeaderRow + " " + customclasses.tableHeaderRow
              }
            >
              <Table.Th className={classes.tableNumberCell}>No.</Table.Th>
              {tableHeader}
              {(window.location.href.split("/")[5] &&
                window.location.href.split("/")[5] !== "current") ||
                window.location.href.split("/")[3] ===
                  "transaction-history" || (
                  <Table.Th style={{ width: "25%" }}>Action</Table.Th>
                )}
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {rowData == null ? (
              <Table.Tr>
                <Table.Td>
                  <Text fw={500} ta="center">
                    Loading
                  </Text>
                </Table.Td>
              </Table.Tr>
            ) : rows.length > 0 ? (
              rows
            ) : (
              <Table.Tr>
                <Table.Td colSpan={Object.keys(rowData).length}>
                  <Text fw={500} ta="center">
                    Nothing found
                  </Text>
                </Table.Td>
              </Table.Tr>
            )}
          </Table.Tbody>
        </Table>
      </div>
    );
  }
);
